import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { SESSION_STATUS_LABELS, type SessionStatus } from '@diana/contracts';
import { CalendarDays, Pencil, X } from 'lucide-react';
import { sessionStatuses } from './crm-format.js';

/** Shared action order and availability for the detail header and desktop list. */
export function ShootActionMenuItems({
  status,
  busy,
  canDelete,
  onEdit,
  onSchedule,
  onCancel,
  onDelete,
  onMove,
}: {
  status: SessionStatus;
  busy: boolean;
  canDelete: boolean;
  onEdit(): void;
  onSchedule(mode: 'schedule' | 'reschedule'): void;
  onCancel(): void;
  onDelete(): void;
  onMove(status: SessionStatus): void;
}) {
  return (
    <>
      <DropdownMenu.Item className="dui-menu__item" onSelect={onEdit}>
        <Pencil size={16} aria-hidden="true" />
        Edit shoot
      </DropdownMenu.Item>
      {status === 'Scheduled' || status === 'Editing' ? (
        <DropdownMenu.Item className="dui-menu__item" onSelect={() => onSchedule('reschedule')}>
          <CalendarDays size={16} aria-hidden="true" />
          Reschedule
        </DropdownMenu.Item>
      ) : status === 'NewRequest' ? (
        <DropdownMenu.Item className="dui-menu__item" onSelect={() => onSchedule('schedule')}>
          <CalendarDays size={16} aria-hidden="true" />
          Schedule shoot
        </DropdownMenu.Item>
      ) : null}
      {status !== 'Canceled' ? (
        <DropdownMenu.Item className="dui-menu__item" disabled={busy} onSelect={onCancel}>
          <X size={16} aria-hidden="true" />
          Cancel shoot
        </DropdownMenu.Item>
      ) : null}
      <DropdownMenu.Separator className="shoot-menu__separator" />
      {sessionStatuses
        .filter((item) => item !== 'Canceled')
        .map((item) => (
          <DropdownMenu.Item
            key={item}
            className="dui-menu__item"
            disabled={busy || item === status}
            onSelect={() => onMove(item)}
          >
            Move to {SESSION_STATUS_LABELS[item]}
          </DropdownMenu.Item>
        ))}
      <DropdownMenu.Separator className="shoot-menu__separator" />
      <DropdownMenu.Item
        className="dui-menu__item shoot-menu__danger"
        disabled={busy || !canDelete}
        onSelect={onDelete}
      >
        Delete shoot
      </DropdownMenu.Item>
    </>
  );
}
